import { render } from "./Tabbar.vue?vue&type=template&id=399b5ed2"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=399b5ed2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__